/** Суммы приходят в копейках целым числом. */
export function money(minor: number, currency = 'RUB'): string {
  return new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(minor / 100)
}

/** «3 ночи», «1 ночь» — без этого выдача выглядит машинной. */
export function nights(n: number): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return `${n} ночь`
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${n} ночи`
  return `${n} ночей`
}

export function guests(n: number): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return `${n} гость`
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return `${n} гостя`
  return `${n} гостей`
}

const BED_LABELS: Record<string, string> = {
  single: 'односпальная кровать',
  double: 'двуспальная кровать',
  queen: 'кровать queen',
  king: 'кровать king',
  twin: 'две односпальные',
  sofa: 'диван',
  bunk: 'двухъярусная',
}

export function bed(type: string, count: number): string {
  const label = BED_LABELS[type] ?? type
  return count > 1 ? `${label} ×${count}` : label
}

export const STATUS_LABELS: Record<string, string> = {
  pending: 'Заявка принята, ждёт подтверждения',
  confirmed: 'Подтверждена',
  checked_in: 'Вы заселены',
  checked_out: 'Проживание завершено',
  cancelled: 'Отменена',
  no_show: 'Не состоялась',
}
